<template>
  <div class="wrapper">
    <c-select
      v-model="localValue"
      type="select"
      :floating-label="field.name"
      :required-mark="field.required"
      :searchable="searchable"
      :items="options"
      :multiple="true"
      :custom-options="field.custom"
      :invalid="!!error"
      :error="error"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CSelect from "@/components/controls2/Select";
import { formatList } from "../utils";

export default {
  components: { CSelect },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: [],
    };
  },
  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),
    searchable() {
      return true;
    },

    variants() {
      const code = this.field.parentId;
      return this.dictionaries[code] || [];
    },
    options() {
      return formatList(this.variants);
    },
  },
  watch: {
    localValue(v) {
      const value = v || [];
      const items = value.filter((i) => !i.custom);
      const customItems = value.filter((i) => i.custom);

      const newValue = {};

      if (items.length) newValue.items = items.map((item) => item.value);
      if (customItems.length) newValue.customItems = customItems.map((item) => item.label);

      this.$emit("input", newValue);
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    this.$store.dispatch("profile/getDictionary", { fieldId: this.field.parentId });
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { items, customItems } = value;

      const list = [
        ...(items || []).map((item) => ({ value: `${item}` })),
        ...(customItems || []).map((item) => ({ value: `${item}`, label: `${item}`, custom: true })),
      ];

      const currentValue = (this.localValue || []).map((i) => i.value);
      const newValue = list.map((i) => i.value);

      if (JSON.stringify(currentValue) !== JSON.stringify(newValue)) {
        this.localValue = list;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  //padding-top: 6px;
}
/deep/ {
  .c-input-container-list-item {
    &-label {
      white-space: normal;
      padding: 3px 0;
      line-height: 1.2;
    }
  }
}
</style>
